import { isNil } from "lodash";

interface PlaidTokenContext {
  currentPath: string;
  token: string;
}

class PlaidLinkTokenStorage {
  #getStorageKey(userId: string) {
    return `${userId}/plaid/token`;
  }

  setTokenContext = (userId: string, currentPath: string, token: string) => {
    const context = {
      currentPath,
      token,
    };
    localStorage.setItem(this.#getStorageKey(userId), JSON.stringify(context));
  };

  getTokenContext = (userId: string): PlaidTokenContext | null => {
    const context = localStorage.getItem(this.#getStorageKey(userId));
    if (!isNil(context)) {
      return JSON.parse(context) as PlaidTokenContext;
    }
    return context;
  };

  clearTokenContext = (userId: string) => {
    localStorage.removeItem(this.#getStorageKey(userId));
  };
}

export default new PlaidLinkTokenStorage();
